<template>
  <div ref="scene" class="landscape" :class="{ 'is-still': paused || !inView || !pageVisible || reducedMotion }" aria-hidden="true">
    <div class="landscape-reveal">
      <img class="landscape-painting" src="/images/hero-silk-landscape-v2.png" alt="" width="1024" height="1536" fetchpriority="high">
      <div class="landscape-haze haze-far"></div>
      <div class="landscape-haze haze-near"></div>
      <div class="landscape-dust">
        <i v-for="n in 16" :key="n" :style="dustStyle(n)"></i>
      </div>
    </div>
    <div class="landscape-shade"></div>
  </div>
</template>

<script>
export default {
  name: 'HeroLandscape',
  props: { paused: Boolean },
  data() { return { inView: false, pageVisible: true, reducedMotion: false } },
  mounted() {
    this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
    this.syncMotion()
    this.syncVisibility()
    this.motionQuery.addEventListener('change', this.syncMotion)
    document.addEventListener('visibilitychange', this.syncVisibility)
    this.observer = new IntersectionObserver(([entry]) => { this.inView = entry.isIntersecting }, { threshold: 0.05 })
    this.observer.observe(this.$refs.scene)
  },
  beforeUnmount() {
    this.observer.disconnect()
    this.motionQuery.removeEventListener('change', this.syncMotion)
    document.removeEventListener('visibilitychange', this.syncVisibility)
  },
  methods: {
    syncMotion() { this.reducedMotion = this.motionQuery.matches },
    syncVisibility() { this.pageVisible = document.visibilityState === 'visible' },
    dustStyle(n) {
      return { left: `${8 + (n * 29) % 84}%`, top: `${49 + (n * 13) % 36}%`, '--delay': `${-n * 1.7}s`, '--duration': `${6 + n % 5}s`, '--drift': `${n % 2 ? -46 : 58}px` }
    }
  }
}
</script>

<style scoped>
.landscape,.landscape-reveal,.landscape-shade{position:absolute;inset:0;pointer-events:none}
.landscape{z-index:-2;overflow:hidden;background:#102421;contain:paint}
.landscape-reveal{overflow:hidden}
.landscape-painting{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:center top;transform-origin:50% 65%}
.landscape-shade{background:linear-gradient(180deg,#10242108 30%,transparent 65%,#101b18 100%)}
.landscape-haze{position:absolute;left:-25%;width:150%;pointer-events:none;mix-blend-mode:screen}
.haze-far{top:40%;height:28%;opacity:.4;background:radial-gradient(ellipse at 32% 58%,#c8d2bfa6,transparent 48%),radial-gradient(ellipse at 72% 42%,#bdc9b899,transparent 43%);filter:blur(12px)}
.haze-near{top:59%;height:29%;opacity:.48;background:radial-gradient(ellipse at 20% 44%,#d4dbc0b3,transparent 42%),radial-gradient(ellipse at 67% 64%,#d4dbc099,transparent 50%);filter:blur(8px)}
.landscape-dust{position:absolute;inset:0;mask-image:linear-gradient(transparent 38%,#000 53%,#000 77%,transparent 92%)}
.landscape-dust i{position:absolute;width:3px;height:6px;border-radius:80% 0 80% 0;background:#e1c587;opacity:0;box-shadow:0 0 5px #e1c58755}
@media(prefers-reduced-motion:no-preference){
  .landscape-reveal{animation:unroll 1.8s cubic-bezier(.2,.65,.3,1) both}
  .landscape-painting{animation:mountain-breath 10s ease-in-out infinite alternate}
  .haze-far{animation:far-mist 9s ease-in-out infinite alternate}
  .haze-near{animation:near-mist 7s ease-in-out infinite alternate}
  .landscape-dust i{animation:gold-drift var(--duration) var(--delay) linear infinite}
  .is-still .landscape-painting,.is-still .landscape-haze,.is-still .landscape-dust i{animation-play-state:paused}
}
@keyframes unroll{from{clip-path:inset(0 0 100% 0);opacity:.3}to{clip-path:inset(0);opacity:1}}
@keyframes mountain-breath{from{transform:scale(1.035) translate(-3px,0)}to{transform:scale(1.16) translate(4px,-12px)}}
@keyframes far-mist{from{transform:translateX(-15%) translateY(0);opacity:.3}to{transform:translateX(16%) translateY(-15px);opacity:.65}}
@keyframes near-mist{from{transform:translateX(18%) translateY(-8px);opacity:.36}to{transform:translateX(-18%) translateY(18px);opacity:.72}}
@keyframes gold-drift{0%{opacity:0;transform:translate(0,-45px) rotate(-35deg)}18%{opacity:.85}55%{opacity:.65;transform:translate(calc(var(--drift) * .45),12px) rotate(95deg)}82%{opacity:.8}100%{opacity:0;transform:translate(var(--drift),70px) rotate(200deg)}}
@media(prefers-reduced-motion:reduce){.landscape-dust{display:none}}
</style>
